"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovernanceType = exports.GoverningTokenType = void 0;
var GoverningTokenType;
(function (GoverningTokenType) {
    GoverningTokenType[GoverningTokenType["Community"] = 0] = "Community";
    GoverningTokenType[GoverningTokenType["Council"] = 1] = "Council";
})(GoverningTokenType = exports.GoverningTokenType || (exports.GoverningTokenType = {}));
var GovernanceType;
(function (GovernanceType) {
    GovernanceType[GovernanceType["Account"] = 0] = "Account";
    GovernanceType[GovernanceType["Program"] = 1] = "Program";
    GovernanceType[GovernanceType["Mint"] = 2] = "Mint";
    GovernanceType[GovernanceType["Token"] = 3] = "Token";
})(GovernanceType = exports.GovernanceType || (exports.GovernanceType = {}));
//# sourceMappingURL=enums.js.map